import Entity from './Entity'
import ActionComponentEntity from './ActionComponentEntity'
import CuratedClassEntity from './CuratedClassEntity'

export default class CuratedSongEntity extends Entity {
  id
  song
  artist
  rpm_a
  rpm_b
  pr_a // (pr_a, pr_b )  when editing/viewing  80 (54)
  pr_b
  coaching_notes
  coaching_notes_simple
  sortOrder
  videoURL
  owner

  classSongActionComponentId // id of connected ActionComponentEntity
  classSongCuratedClassId // id of connected CuratedClassEntity

  curatedClass
  actionComponent

  constructor(initialValues = {}) {
    let _defaults = { sortOrder: 1 }
    super({ ..._defaults, ...initialValues })

    CURATED_SONG_ENTITY_STRING_LIST.forEach(field => {
      if (this[field] === null) {
        this[field] = ''
      }
    })
    CURATED_SONG_ENTITY_NUMBER_LIST.forEach(field => {
      if (this[field] === null) {
        this[field] = 0
      }
    })

    if (initialValues !== null) {
      const { curatedClass, actionComponent } = initialValues
      if (curatedClass !== undefined) {
        this.curatedClass = new CuratedClassEntity(curatedClass)
        if (curatedClass !== null) {
          this.classSongCuratedClassId = curatedClass.id
        }
      }
      if (actionComponent !== undefined) {
        this.actionComponent = new ActionComponentEntity(actionComponent)
        if (actionComponent !== null) {
          this.classSongActionComponentId = actionComponent.id
        }
      }
    }
  }

  prOptions(prOption) {
    const options = [
      'none',
      'L',
      'M',
      'H',
      'LMH',
      'LM',
      'MH',
      'L and M/H alt',
      'H then L',
      'L then H',
    ]
    return options[prOption]
  }
}

export const CURATED_SONG_ENTITY_NUMBER_LIST = ['rpm_a', 'rpm_b', 'sortOrder']
export const CURATED_SONG_ENTITY_STRING_LIST = [
  'song',
  'artist',
  'coaching_notes',
  'coaching_notes_simple',
  'pr_a',
  'pr_b',
  'videoURL',
]
